import { useNavigate } from "react-router-dom";
import cleanerOne from "../../../assets/cleanerOne.png";
import cleanerTwo from "../../../assets/cleanerTwo.png";
import plusIcon from "../../../assets/plusIcon.png";
import styles from "./CreateCheckListTab.module.css";
import { List } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ChecklistMiddleware from "../../../store/Middlewares/ChecklistMiddleware";
import dummyImg from "../../../assets/dummy.png";
import { useEffect } from "react";
import { IMG_URL } from "../../../store/Apis";
import AlertAction from "../../../store/Actions/AlertActions";

const CreateCheckListTab = () => {
  const navigate = useNavigate();

  useEffect(() => {
    getChecklist();
    getLanguage();
  }, [])

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  const CheckList = useSelector(state => state.CheckListReducer.CheckList)
  const CheckListPagination = useSelector(state => state.CheckListReducer.CheckListPagination)


  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const getChecklist = () => {
    let data = {
      next_page_url: undefined
    }
    dispatch(ChecklistMiddleware.getChecklist(data))
  }
  const onPressSendChecklist = (id) => {
    let data = {
      id: id,
      next_page_url: undefined
    }
    dispatch(ChecklistMiddleware.sendChecklist(data))
      .then((data) => {
        dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))

      })
      .catch((error) => console.log(error))
  }


  const onPressLoadMore = () => {
    let data = {
      next_page_url: CheckListPagination?.links?.next
    }
    dispatch(ChecklistMiddleware.getChecklist(data))
  };
  const loadMore =
    CheckListPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;


  return (
    <div className={styles.createChecklist_mainContainer}>

      <List
        grid={{
          gutter: 16,
          //   xs: 2,
          sm: 1,
          md: 1,
          lg: 1,
          xl: 2,
          xxl: 2,
        }}
        className={styles.createChecklist_list}
        dataSource={CheckList}
        footer={loadMore}
        renderItem={(item) => (
          console.log('item', item),
          <div key={item?.id} className={styles.createChecklist_listItem}>
            <div className={styles.createChecklist_img}>
              <img src={item?.cleaner_profile_image ? IMG_URL + item?.cleaner_profile_image : dummyImg} />
            </div>
            <div className={styles.createChecklist_context}>
              <div className={styles.createChecklist_heading}>
                <h3>{item?.name}</h3>
                {/* <p>{' ' + item?.job_location?.zipcode + ',' + item?.job_location?.street + ',' + item?.job_location?.state}</p> */}
              </div>
              <p className={styles.createChecklist_para}>{item?.cleaner_name}</p>
              <p>{item?.job_location?.address}</p>
              <div style={{ display: 'inline' }}>

                {item?.items?.map((checklistitem, index) => {
                  return (
                    <>
                      <span>{`${checklistitem?.name} ${index + 1 < item?.items?.length ? ', ' : ''}`} </span>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      />
      <div className={styles.plusIcon} onClick={() => navigate('/contractorHome/Checklist/CreateChecklist')}>
        <img src={plusIcon} />
      </div>
    </div>
  );
};
export default CreateCheckListTab;
